import { DirectiveOptions } from 'vue';
import AuthorityStore from '@/domain/security/authority.store';

function applyAuthorities(element: any, authorities: string[]) {
  element.style.display = 'none';
  AuthorityStore.hasAuthority(authorities).then((response) => {
    if (response) {
      element.style.display = 'block';
    }
  });
}

export const hasAuthority: DirectiveOptions = {
  inserted(element, binding) {
    const authorities = binding && binding.expression
      ? binding.expression.replace(/'/g, '').split(',')
      : [];
    applyAuthorities(element, authorities);
  },
};

export const hasManagerAuthority: DirectiveOptions = {
  inserted(element) {
    applyAuthorities(element, ['MANAGER']);
  },
};

export const hasAdministratorAuthority: DirectiveOptions = {
  inserted(element) {
    applyAuthorities(element, ['ADMINISTRATOR']);
  },
};

export const hasAdministratorOrManagerAuthority: DirectiveOptions = {
  inserted(element) {
    applyAuthorities(element, ['ADMINISTRATOR', 'MANAGER']);
  },
};
